import React from 'react'
import Link from '../Link'
import * as styles from './index.module.css'

const Icon = () => (
  <svg
    className={styles.icon}
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.36634 9.7457C3.53915 9.91519 3.76958 9.99994 4 9.99994C4.23042 9.99994 4.46085 9.91519 4.63366 9.7457L7.85959 6.58186C8.0468 6.39824 8.0468 6.10163 7.85959 5.91802L7.26913 5.33892C7.08191 5.15531 6.77948 5.15531 6.59226 5.33892L4.90729 6.99146V0.466041C4.90729 0.211803 4.69127 -6.10352e-05 4.43204 -6.10352e-05H3.59676C3.33753 -6.10352e-05 3.12151 0.211803 3.12151 0.466041V6.99146L1.40774 5.33892C1.22052 5.15531 0.918091 5.15531 0.730873 5.33892L0.140414 5.91802C-0.0468047 6.10163 -0.0468047 6.39824 0.140414 6.58186L3.36634 9.7457Z"
      fill="#5E79FB"
    />
  </svg>
)

const Cell = ({ data }) => {
  return (
    <div className={styles.cell}>
      {data.length > 1 && <div></div>}
      {data.map((d) =>
        d.indexOf('null') !== -1 || d === null ? (
          <></>
        ) : d.indexOf('|') !== -1 ? (
          d.indexOf('zip') !== -1 ? (
            <a rel="noreferrer" href={d.split('|')[0]} download>
              {d.split('|')[1]}
              <Icon />
            </a>
          ) : (
            <a target="_blank" rel="noreferrer" href={d.split('|')[0]}>
              {d.split('|')[1]}
              <Icon />
            </a>
          )
        ) : (
          <>
            {d.indexOf(',') !== -1 ? (
              <p
                className={styles.p}
                dangerouslySetInnerHTML={{
                  __html: d.split(',').join(',<br />'),
                }}
              ></p>
            ) : (
              <p className={styles.p}>{d}</p>
            )}
          </>
        )
      )}
    </div>
  )
}

const convertTitle = (title) =>
  title.indexOf('|') !== -1 ? title.split('|')[0] : title

const convertToArray = (data) => {
  if (!(data.indexOf('null') !== -1 || data === null)) {
    if (data.indexOf(',') !== -1) {
      return data.split(',')
    } else {
      return [...data]
    }
  } else {
    return [...data]
  }
}

const DownloadList = ({ title, link, data, arr, large }) => {
  return (
    <div className={styles.container}>
      {title && (
        <div
          className={`${styles.cell}  ${large ? styles.large : styles.normal}`}
        >
          {large ? (
            <h4>{convertTitle(title)}</h4>
          ) : (
            <h5>{convertTitle(title)}</h5>
          )}
        </div>
      )}

      {arr &&
        arr.map((item, index) => (
          <div key={item + index} className={styles.cell}>
            {link ? (
              <Link to={link}>
                {item}
                <Icon />
              </Link>
            ) : large ? (
              <h4>{item}</h4>
            ) : (
              <h5>{item}</h5>
            )}
          </div>
        ))}

      {data && data.os0 && <Cell data={convertToArray(data.os0)} />}
      {data && data.os1 && <Cell data={convertToArray(data.os1)} />}
      {data && data.os2 && <Cell data={convertToArray(data.os2)} />}
      {data && data.windows && <Cell data={convertToArray(data.windows)} />}
      {data && data.mac && <Cell data={convertToArray(data.mac)} />}
      {data && data.linux && <Cell data={convertToArray(data.linux)} />}
      {data && data.other && <Cell data={convertToArray(data.other)} />}
    </div>
  )
}

export default DownloadList
